module.exports = __webpack_public_path__ + "PTSans-Narrow.7c5411692b2ff2101268.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/PTSans-Narrow.ttf
// module id = ../../../../../src/assets/customfonts/PTSans-Narrow.ttf
// module chunks = styles